<mat-expansion-panel #matExpansionPanel [expanded]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title class="mat-panel-title">
      <div class="title">STEP 2 - SEND CONTRACT TO LANDOWNER</div>
      <button
        mat-stroked-button
        color="primary"
        (click)="downloadContract($event)"
        *ngIf="matExpansionPanel.expanded"
        class="download-button">
        <fa-icon [icon]="['far', 'download']" class="green"></fa-icon>
        Download Contract
      </button>
    </mat-panel-title>
    <mat-panel-description>
      <div *ngIf="stepComplete">
        <fa-icon [icon]="['fas', 'check']" class="green size-20"></fa-icon>
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <mat-divider></mat-divider>

  <div class="section-content">
    <mat-radio-group
      *ngIf="!stepComplete"
      [(ngModel)]="transmissionOption"
      [disabled]="stepComplete || !isCurrentStep"
      class="transmission-options">
      <mat-radio-button *ngFor="let option of options" [value]="option.value" data-cy="send-contract-option">
        <span [innerHTML]="option.text"></span>
      </mat-radio-button>
    </mat-radio-group>

    <div *ngIf="stepComplete">
      {{
        site.contractEnvelopeId === null
          ? 'Contract sent manually to ' + emailAddress
          : 'Contract sent via DocuSign to ' + emailAddress
      }}
    </div>
    <div *ngIf="errorDetail !== null" class="error">
      {{ errorDetail }}
    </div>

    <button
      (click)="sendContract()"
      *ngIf="!stepComplete && isCurrentStep"
      color="primary"
      data-cy="button-continue"
      disabled="{{ transmissionOption === null }}"
      mat-raised-button>
      Continue
    </button>
  </div>
</mat-expansion-panel>
